<template>
    <svg style="cursor: pointer" :width="width" :height="height" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 36 36" xml:space="preserve">
        <g>
	<g>
		<g>
			<path class="svg-outline-color" d="M18,1c9.37,0,17,7.63,17,17s-7.63,17-17,17S1,27.37,1,18S8.63,1,18,1 M18,0C8.06,0,0,8.06,0,18
				s8.06,18,18,18s18-8.06,18-18S27.94,0,18,0L18,0z"/>
		</g>

        <path class="svg-secondary-color" d="M21.5,15h-8v1h8V15z M21.5,12h-8v1h8V12z M13.5,19h4v-1h-4V19z M29.52,14.39l-1.41-1.41
			c-0.39-0.39-1.02-0.39-1.41,0l-1.19,1.19V10c0-1.1-0.9-2-2-2h-12c-1.1,0-2,0.9-2,2v16c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2v-6.17
			l4.02-4.02C29.91,15.42,29.91,14.78,29.52,14.39z M24.5,26c0,0.55-0.45,1-1,1h-12c-0.55,0-1-0.45-1-1V10c0-0.55,0.45-1,1-1h12
			c0.55,0,1,0.45,1,1v5.17l-7,7V25h2.83l4.17-4.17V26z M19.91,24H18.5v-1.41l6.78-6.78l1.41,1.41L19.91,24z"/>
	</g>
</g>
</svg>
</template>

<script>

export default {
    name: "commentIcon",
    props: {
        width: {
            type: Number,
            default: 36,
        },
        height: {
            type: Number,
            default: 36
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/common/components/svg/shared/commentIcon.vue